import { Typography } from "antd";
import React from "react";
import { TinyDivider } from "@bindeleddet/core/components";
import image from "../../assets/images/BLCover.jpg";
import { StyledCoverImage, StyledImageWrapper } from "./style";

const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <>
      <StyledImageWrapper>
        <StyledCoverImage src={image} />
      </StyledImageWrapper>

      <div style={{ padding: "5%" }}>
        <Title level={1} style={{ display: "block" }}>
          Personvern
        </Title>
        <TinyDivider width="2em" />

        <Title level={3}>Generelt</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Denne personvernserklæringen forklarer hvordan Bindeleddet NTNU henter inn og bruker personlig data om brukere
          av Bindeleddet NTNUs tjenester. Bindeleddet NTNU er databehandlingsansvarlig for din bruk av Bindeleddet NTNUs
          tjenester og kan kontaktes på <a href="mailto:it@bindeleddet.no">it@bindeleddet.no</a>. Denne
          personvernerklæringen har ikke til hensikt å begrense dine lovbestemte personvernsrettigheter.
        </Paragraph>

        <Title level={3}>Rettslig grunnlag for prosessering av data</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Ved å godkjenne denne personvernerklæringen gir du Bindeleddet NTNU rett til å prosessere personlige data som
          beskrevet videre. Bindeleddet NTNU har ikke til hensikt å prosessere spesielle kategorier av data som etnisk
          bakgrunn, politiske ståsted, religion, medlemsskap i fagforening, genetiske data, biometriske data for å
          identifisere personer, helseopplysninger eller opplysninger om seksuell legning.
        </Paragraph>

        <Title level={3}>
          Hvordan og hvilke personlige data som blir samlet gjennom din bruk av Bindeleddet NTNUs tjenester
        </Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU kan samle inn personlig data:
          <ol>
            <li>gjennom din opprettelse og endring av brukerprofil hos Bindeleddet NTNU</li>
            <li>ved å monitorere din bruk av Bindeleddet NTNUs tjenester</li>
          </ol>
          Bindeleddet benytter seg også av tredjepartstjenester. Bruk av disse utføres i henhold til
          tredjepartstjenestene sine respektive vilkår. Per nåværende tidspunkt benytter Bindeleddet seg av følgende
          tredjepartsjenester:
          <ul>
            <li>
              Google, i samsvar med følgende behandlingsbestemmelser:{" "}
              <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
            </li>
            <li>
              New Relic, i samsvar med følgende behandlingsbestemmelser:{" "}
              <a href="https://newrelic.com/termsandconditions/privacy">
                https://newrelic.com/termsandconditions/privacy
              </a>
            </li>
            <li>
              Cloudfare, i samsvar med følgende behandlingsbestemmelser:{" "}
              <a href="https://www.cloudflare.com/privacypolicy/">https://www.cloudflare.com/privacypolicy/</a>
            </li>
          </ul>
          Ved å registrere en bruker hos Bindeleddet NTNU, gir du Bindeleddet NTNU lov til å prosessere følgende av dine
          personlige data:
          <ul>
            <li>Navn</li>
            <li>Brukernavn</li>
            <li>Telefonnummer</li>
            <li>Studenkortnummer</li>
            <li>E-postadresse</li>
            <li>Allergier</li>
            <li>Studieprogram</li>
            <li>Årskull</li>
            <li>Deltakelse på arrangementer</li>
            <li>Advarsler på arrangementer</li>
            <li>Antall innlogginger</li>
            <li>Tid for siste innlogging</li>
            <li>Sist brukte IP-adresse</li>
          </ul>
        </Paragraph>

        <Title level={3}>Hensikt for prosessering av data</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU vil prosessere nevnt informasjon for å:
          <ol>
            <li>gi bruker tilgang til Bindeleddet NTNUs tjenester</li>
            <li>forbedre Bindeleddet NTNUs tjenester</li>
            <li>utføre våre lovpålagte forpliktelser til deg som datasubjekt</li>
          </ol>
        </Paragraph>

        <Title level={3}>Oppbevaringsperiode</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU sletter all personlig data om deg idet du sletter din brukerprofil eller trekker samtykke til
          denne personvernserklæringen. Dette kan gjøres under “rediger profil” på bindeleddet.no eller ved å sende en
          mail til <a href="mailto:it@bindeleddet.no">it@bindeleddet.no</a>. Ved opphør av brukerforhold, med andre ord
          når du blir uteksaminert fra NTNU, beholder Bindeleddet NTNU personlige data om deg i opptil ett år. Etter
          dette vil all personlig data bli anonymisert.
        </Paragraph>

        <Title level={3}>Hvor data blir prosessert</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU benytter seg av prosessorer utenfor Norge. Underleverandørs prosessering av data på vegne av
          Bindeleddet NTNU skjer i henhold til følgende vilkår:{" "}
          <a href="https://www.digitalocean.com/legal/data-processing-agreement/.">
            https://www.digitalocean.com/legal/data-processing-agreement/.
          </a>
        </Paragraph>

        <Title level={3}>Videreformidling av personlige data</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU vil ikke dele dine personlige data med tredjepart med mindre minst en av følgende gjelder:
          <ol>
            <li>Det er lovpålagt</li>
            <li>
              Det er behov for å dele navnet ditt i henhold til åpenhetsloven og bokføringsforskriften § 5-10 om
              bevertningsutgifter
            </li>
            <li>Du som bruker har godtatt dette eksplisitt</li>
          </ol>
        </Paragraph>

        <Title level={3}>Dine rettigheter som datasubjekt</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          <Paragraph underline>Rett til tilgang til og rett til endring og sletting av personlige data</Paragraph>
          Ved forespørsel vil Bindeleddet NTNU gi deg tilgang til alle personlige data Bindeleddet NTNU har lagret om
          deg med mindre disse dataene er tilgjengelige for deg på andre måter. Hvis personlige data er feil eller
          misvisende, kan du be om at dataen blir rettet eller fjernet. Som registrert bruker kan du få tilgang til,
          rette og fjerne dine personlige data gjennom Bindeleddet NTNU.
          <br />
          <br />
          <Paragraph underline>Rettigheter i forbindelse med videreformidling</Paragraph>I alle tilfeller hvor
          Bindeleddet NTNU får lov til å videreformidle personlige data om en tredjepart, vil det blir forsikret om at
          personen som får tilgang til dataene gir deg samme rettigheter som er presentert i dette dokumentet hva angår
          prosesseringen av slike personlige data.
          <br />
          <br />
          <Paragraph underline>Rett til datatilgjengelighet</Paragraph>
          Du har rett til å motta dine personlige data som du har oppgitt til Bindeleddet NTNU på et strukturert og
          lesbart format og har rett til å videreformidle disse dataene til en annen aktør uten hindring fra Bindeleddet
          NTNU.
          <br />
          <br />
          <Paragraph underline>Rett til å klage til tilsynsmyndigheter</Paragraph>
          Du har rett til å klage til en tilsynsmyndighet dersom du mener at prosesseringen av dine personlige data er i
          strid med dine rettigheter.
          <br />
          <br />
          <Paragraph underline>Kontaktinformasjon</Paragraph>
          Alle forespørsler angående de ovennevnte rettigheter kan sendes til{" "}
          <a href="mailto:it@bindeleddet.no">it@bindeleddet.no</a>
        </Paragraph>

        <Title level={3}>Endring av personvernerklæring</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU kan til enhver tid endre denne personvernerklæringen ved å publisere en revidert versjon på
          denne siden. Dersom den reviderte versjonen inneholder betydelige endringer i hvordan personlige data
          prosesseres, vil du bli bedt om nytt samtykke før du kan fortsette å bruke Bindeleddet NTNUs tjenester.
        </Paragraph>
      </div>
    </>
  );
};

export default PrivacyPolicy;
